import { Box, Grid, Paper} from "@mui/material";
import PlainLayout from "components/SeatLayout/PlainLayout";
import CustomSeatLayout from "components/SeatLayout/CustomLayout";
import { useSnackbar } from "notistack";
import { useCallback, useEffect, useState } from "react";
import { getVendorLayout } from "services/vendorDashboard";
import { getDbFormat,  } from "utils/common";

export default function VendorSeatLayout({pageFilters}) {
  
  const { enqueueSnackbar } = useSnackbar();
  const [layout, setLayout] = useState({});

  const getSeatLayout = useCallback((pageFilters) => {
    const [from, to ]= pageFilters.filterDates;
    const data = {
      from: getDbFormat(from), to: getDbFormat(to), propertyId: pageFilters.library.id, propertyType: 'LIBRARY'
    };

    getVendorLayout(data).then(({response, error}) => {
      if(response){
        setLayout(response);
      } else {
        setLayout([]);
        enqueueSnackbar((response?.message || error), {variant: 'error'});
      }
    });
  }, [enqueueSnackbar]);
  
  useEffect(() => {
    if(pageFilters){
      getSeatLayout(pageFilters);
    }
  }, [getSeatLayout, pageFilters]);
  
  return (
    <Paper sx={{ minWidth: 275, py: 2, px: 3, minHeight: "calc(100vh - 100px )" }} elevation={0}>
     
      <Box noValidate >
        <Grid container columnSpacing={4} rowSpacing={2} >
          <Grid item xs={12} sm={12} md={12} lg={12} >
              <Box component="div" sx={{  maxHeight: 720, width: '100%' }}>
                {layout?.librarySeats?.length > 0 && !(layout?.librarySeatLayout) ? <PlainLayout layout={layout.librarySeats} />: <CustomSeatLayout layout={layout?.librarySeatLayout?.seatLayout} />}
              </Box>
            </Grid>
        </Grid>
      </Box>
    </Paper>
  );
}
